document.addEventListener('DOMContentLoaded', function () {
  // Guard so the listener won't be installed twice if the script executes more than once
  if (window._nostoBundleAtcListenerInstalled) {
    console.log('nosto: ATC listener already installed, skipping.');
    return;
  }
  window._nostoBundleAtcListenerInstalled = true;

  const CCART_SELECTOR = '.js-drawer-open-cart';

  function checkNostoList() {
    var nostoList = document.querySelector('.nosto-list');
    if (!nostoList) {
      setTimeout(checkNostoList, 100);
      return;
    }

    // hide initially and show on flickity ready
    nostoList.style.visibility = 'hidden';
    nostoList.addEventListener('ready.flickity', function () {
      nostoList.style.visibility = 'visible';
    });

    console.log('nosto: list found');
  }

  function bundleAddToCart(quantity, variantId, sourceBtn) {
    if (!variantId) return;

    // mark button busy
    if (sourceBtn) {
      sourceBtn.disabled = true;
      sourceBtn.classList.add('is-busy');
    }

    let data = {
      items: [{ id: variantId, quantity: quantity }]
    };

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
      .then(response => {
        document.dispatchEvent(new Event('cart:build'));
        // slight delay to avoid strange re-entrancy if click listeners act on cart open
        setTimeout(() => {
          const ccart = document.querySelector(CCART_SELECTOR);
          if (ccart) ccart.click();
        }, 50);
        return response.json();
      })
      .catch(error => {
        console.error('nosto bundle add error:', error);
      })
      .finally(() => {
        if (sourceBtn) {
          sourceBtn.disabled = false;
          sourceBtn.classList.remove('is-busy');
          delete sourceBtn.dataset.nostoProcessing;
        }
      });
  }

  // Delegated click handler (installed once)
  document.addEventListener('click', function (e) {
    const button = e.target.closest('.nosto-bundle-list-item .btn--full.add-to-cart');
    if (!button) return;

    // Per-button quick-guard: ignore if already processing
    if (button.dataset.nostoProcessing === '1') {
      console.log('nosto: ignored duplicate/rapid click for same button');
      return;
    }
    button.dataset.nostoProcessing = '1';
    // fallback: clear guard after 2s in case something goes wrong
    setTimeout(() => { if (button) delete button.dataset.nostoProcessing; }, 2000);

    // Debug traces so you can see the stack and timestamp for each invocation
    console.log('BUNDLE ATC CLICKED', new Date().toISOString(), button);
    console.trace();

    const parent = button.closest('.nosto-bundle-list-item');
    const optionSelect = parent && parent.querySelector('.bundle-options');
    let variantId = optionSelect ? optionSelect.value : null;

    if (!variantId) {
      const sizeInput = parent.querySelector('.nosto-bundle-sizes-container input:checked, .nosto-bundle-sizes-container input');
      variantId = sizeInput ? sizeInput.value : null;
    }

    if (variantId) {
      bundleAddToCart(1, variantId, button);
    } else {
      // clear guard if we didn't actually add
      delete button.dataset.nostoProcessing;
    }
  });

  checkNostoList();
});
